import React from 'react';
import PropTypes from 'prop-types';

import { balanceApi } from 'helpers/api/balance';

import { Icon } from 'components/Icon';
import { HiddenInput } from 'components/HiddenInput';
import { ButtonIcon } from 'components/Button';
import { CalculatorModal } from 'components/CalculatorModal';

const TableExitInstruments = ({
  data,
  opened,
  canChange,
  rentSum,
  handleRemoveComponent,
  handleAddComponent,
  handleUpdateComponent,
  handleRemove,
  handleChangeCalculator,
  handleOpen,
  onUpdate,
  rateVAT,
  calculator,
  handleCalculator,
  isFullPledge,
  setIsFullPledge,
}) => {
  const recalculateRentSum = (inst) => {
    balanceApi.calculateInstrumentAmount(inst).then(({ data } = {}) => {
      handleChangeCalculator(data);
    });
  };

  const onDaysLateChange = (inst, value) => {
    const newInst = { ...inst, days_late: value };
    onUpdate(inst.id, newInst);
    recalculateRentSum(newInst);
  };

  const onQuantityOUTChange = (inst, value) => {
    const newInst = { ...inst, quantityOUT: value };
    onUpdate(inst.id, newInst);
  };

  return (
    <table className="table-instruments">
      <thead>
        <tr className="table-inst-htr">
          <th className="table-inst-th" width="30px">
            №
          </th>
          <th className="table-inst-th" width="16px" style={{ borderRight: 'none', textAlign: 'left' }}></th>
          <th className="table-inst-th" align="start">
            Наименование
          </th>
          <th className="table-inst-th" width="50px">
            Кол-во выдано
          </th>
          <th className="table-inst-th" width="75px">
            Кол-во возвращено
          </th>

          <th className="table-inst-th" width="50px">
            Опоздание
          </th>
          <th className="table-inst-th" width="75px">
            Залог
          </th>
          <th className="table-inst-th" width="75px">
            Сумма доплаты
          </th>
          <th className="table-inst-th" width="95px">
            Сумма возврата
          </th>
          <th className="table-inst-th" width="75px"></th>
        </tr>
      </thead>

      <tbody>
        {data &&
          data.map((inst, i) => {
            let icon = 'instrument';

            if (inst.is_priced_by_wear) {
              icon = 'wheel';
            } else if (inst.components && opened.includes(inst.id)) {
              icon = 'tableminus';
            } else if (inst.components && !opened.includes(inst.id)) {
              icon = 'tableplus';
            }

            return (
              <React.Fragment key={inst.id}>
                <tr className="table-inst-tr" onClick={() => handleOpen(inst)}>
                  <th className="table-inst-th text-light">{i + 1}</th>

                  <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}>
                    <Icon name={icon} style={{ margin: 'auto' }} />
                  </th>

                  <th className="table-inst-th text-light" align="start">
                    {inst.title}
                  </th>
                  <th className="table-inst-th" width="50px">
                    {inst.oldQuantity}
                  </th>
                  <th className="table-inst-th" width="50px">
                    
                    <HiddenInput
                        canChange={canChange}
                        value={inst.quantityOUT}
                        onChange={(value) => onQuantityOUTChange(inst, value)}
                        min={1}
                        max={inst.oldQuantity}
                      />
                  </th>

                  <th className="table-inst-th" width="100px">
                    {inst.is_priced_by_wear ? (
                      <div>-</div>
                    ) : (
                      <HiddenInput
                        canChange={canChange}
                        postfix=" сут."
                        value={inst.days_late || 0}
                        onChange={(value) => onDaysLateChange(inst, value)}
                        min={"0"}
                        max={inst.days_late > 365 ? inst.days_late : 365}
                      />
                    )}
                  </th>

                  <th className="table-inst-th" width="50px">
                    {inst.pledge * inst.quantityOUT || 0} грн.
                  </th>

                  <th className="table-inst-th" width="75px">
                    {inst.surcharge_amount * inst.quantityOUT || 0} грн.
                  </th>

                  <th className="table-inst-th" width="75px">
                    {inst.refund_amount > 0 && `${inst.refund_amount * inst.quantityOUT || 0}грн.`}
                  </th>
                  <th className="table-inst-th double-th">
                    <Icon name="trash" onClick={() => handleRemove(inst.id)} />
                    <Icon name="calculator" onClick={() => handleCalculator(inst)} />
                    {calculator?.id === inst.id && (
                      <CalculatorModal
                        instrument={calculator || null}
                        onUpdate={handleChangeCalculator}
                        disabled={true}
                        onClose={() => handleCalculator(null)}
                        isFullPledge={isFullPledge}
                        setIsFullPledge={setIsFullPledge}
                      />
                    )}
                  </th>
                </tr>

                {opened.includes(inst.id) &&
                  inst.components &&
                  inst.components.map((comp) => (
                    <tr key={comp.id} className="table-inst-tr">
                      <th className="table-inst-th text-light"></th>

                      <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

                      <th className="table-inst-th text-light" align="start">
                        {comp.title}
                      </th>

                      <th className="table-inst-th">
                        <HiddenInput
                          canChange={canChange}
                          value={comp.quantity || 0}
                          onChange={(value) => handleUpdateComponent(inst, comp.id, value)}
                        />
                      </th>

                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="50px"></th>
                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="75px"></th>
                      <th className="table-inst-th" width="95px"></th>

                      <th className="table-inst-th double-th">
                        {canChange && (
                          <Icon
                            name="trash"
                            onClick={(e) => handleRemoveComponent(inst, comp.id)}
                            style={{ margin: 'auto' }}
                          />
                        )}
                      </th>
                    </tr>
                  ))}
                {opened.includes(inst.id) && canChange && (
                  <tr className="table-inst-tr" style={{ padding: '8px' }}>
                    <th className="table-inst-th text-light"></th>
                    <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>
                    <th className="table-inst-th text-light" align="start">
                      <ButtonIcon
                        className="btn-add-component"
                        onClick={() => handleAddComponent(inst)}
                        icon="plus"
                        text="Добавить компонент"
                      />
                    </th>

                    <th className="table-inst-th" width="50px"></th>
                    <th className="table-inst-th" width="75px"></th>
                    <th className="table-inst-th" width="50px"></th>
                    <th className="table-inst-th" width="75px"></th>
                    <th className="table-inst-th" width="75px"></th>
                    <th className="table-inst-th" width="95px"></th>

                    <th className="table-inst-th"> </th>
                  </tr>
                )}
              </React.Fragment>
            );
          })}

        <tr className="table-inst-tr">
          <th className="table-inst-th text-light"></th>

          <th className="table-inst-th text-light" style={{ borderRight: 'none', textAlign: 'left' }}></th>

          <th className="table-inst-th text-light" align="start"></th>

          <th className="table-inst-th" width="50px"></th>

          <th className="table-inst-th" width="75px"></th>

          <th className="table-inst-th" width="75px"></th>

          <th className="table-inst-th" width="95px">
            {rentSum.pledge} грн.
          </th>

          <th className="table-inst-th"> {rentSum.surchargeAmount} грн.</th>
          <th className="table-inst-th"> {rentSum.refundAmount > 0 && `${rentSum.refundAmount} грн.`}</th>
          <th className="table-inst-th"> </th>
        </tr>
      </tbody>
    </table>
  );
};

TableExitInstruments.propTypes = {
  data: PropTypes.array,
  opened: PropTypes.array,
  canChange: PropTypes.bool,
  rentSum: PropTypes.object,
  handleRemoveComponent: PropTypes.func,
  handleAddComponent: PropTypes.func,
  handleUpdateComponent: PropTypes.func,
  handleRemove: PropTypes.func,
  handleChangeCalculator: PropTypes.func,
  handleOpen: PropTypes.func,
  onUpdate: PropTypes.func,
  rateVAT: PropTypes.number,
  calculator: PropTypes.object,
  handleCalculator: PropTypes.func,
  isFullPledge: PropTypes.bool,
  setIsFullPledge: PropTypes.func,
};

TableExitInstruments.defaultProps = {
  opened: [],
  canChange: true,
};

export { TableExitInstruments };
